import React from 'react';
import { Plug, Repeat, Shield, Cpu, ClipboardList, HeadphonesIcon } from 'lucide-react';

export function IntegrationFeatures() {
  return (
    <div className="bg-gray-900 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl text-white mb-4">
            Seamlessly integrate to multiple Property Management Systems
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Extract data, get rates and availabilities, post reservations, listen to events and much more
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Single API Integration */}
          <div className="bg-gray-800 p-8 rounded-lg shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center mb-4">
              <div className="bg-[#4A8DE0] rounded-lg p-3">
                <Plug className="h-6 w-6 text-white" />
              </div>
              <h3 className="ml-4 text-lg text-white">Single API integration</h3>
            </div>
            <p className="text-gray-400">
              One integration to connect with all your systems, simplifying your technical infrastructure.
            </p>
          </div>

          {/* Real-time Synchronization */}
          <div className="bg-gray-800 p-8 rounded-lg shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center mb-4">
              <div className="bg-[#4A8DE0] rounded-lg p-3">
                <Repeat className="h-6 w-6 text-white" />
              </div>
              <h3 className="ml-4 text-lg text-white">Real-time synchronization</h3>
            </div>
            <p className="text-gray-400">
              Keep your data synchronized across all systems in real-time for seamless operations.
            </p>
          </div>

          {/* Secure Transmission */}
          <div className="bg-gray-800 p-8 rounded-lg shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center mb-4">
              <div className="bg-[#4A8DE0] rounded-lg p-3">
                <Shield className="h-6 w-6 text-white" />
              </div>
              <h3 className="ml-4 text-lg text-white">Secure transmission</h3>
            </div>
            <p className="text-gray-400">
              Enterprise-grade security ensuring your data is protected during transmission.
            </p>
          </div>

          {/* Automated Mapping */}
          <div className="bg-gray-800 p-8 rounded-lg shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center mb-4">
              <div className="bg-[#4A8DE0] rounded-lg p-3">
                <Cpu className="h-6 w-6 text-white" />
              </div>
              <h3 className="ml-4 text-lg text-white">Automated mapping</h3>
            </div>
            <p className="text-gray-400">
              Intelligent data mapping and transformation between different systems.
            </p>
          </div>

          {/* Audit Trails */}
          <div className="bg-gray-800 p-8 rounded-lg shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center mb-4">
              <div className="bg-[#4A8DE0] rounded-lg p-3">
                <ClipboardList className="h-6 w-6 text-white" />
              </div>
              <h3 className="ml-4 text-lg text-white">Audit trails</h3>
            </div>
            <p className="text-gray-400">
              Comprehensive audit trails for tracking all data movements and changes.
            </p>
          </div>

          {/* Expert Support */}
          <div className="bg-gray-800 p-8 rounded-lg shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center mb-4">
              <div className="bg-[#4A8DE0] rounded-lg p-3">
                <HeadphonesIcon className="h-6 w-6 text-white" />
              </div>
              <h3 className="ml-4 text-lg text-white">Expert Support</h3>
            </div>
            <p className="text-gray-400">
              Industry experts with in-depth PMS knowledge to assist you daily.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}